import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import ReactDOM from "react-dom";

import ImageViewer from "components/ImageViewer";
import {
  closeImageViewer,
  getImageViewerList,
  fillInitialDataImageViewer,
  updateImageViewerDetails,
} from "./redux/ImageViewerActions";

const ImageViewerModule = () => {
  const dispatch = useDispatch();

  const activeNumber = useSelector((state) => state.thread?.activeFromNumber);
  const activeChat = useSelector(
    (state) => activeNumber && state.thread.threads[activeNumber],
  );

  const imageViewerData = useSelector((state) => state.imageViewer);

  const activeConversationId = useSelector(
    (state) => state.thread?.activeConversation?.id,
  );

  const filteredData = activeChat?.messages?.filter(
    (item) => item?.message?.media_url,
  );

  useEffect(() => {
    const formattedData = filteredData?.map((item) => ({
      id: item.message.id,
      src: item.message.media_url,
      messageType: item.messageType === "CustomerMessage" ? "Received" : "Sent",
      date: item.message.created_at_utc,
      name: item.message.media_file_name,
      contentType: item.message.message_content_type,
    }));
    if (formattedData) {
      dispatch(fillInitialDataImageViewer(formattedData, activeConversationId));
    }
  }, [dispatch, filteredData?.length]);

  const dataList = [...Object.values(imageViewerData.dataList)];

  const startIndex = dataList?.findIndex(
    (element) => element.id === imageViewerData.data.id,
  );

  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    if (activeItem === 0 && dataList && dataList[0]) {
      dispatch(getImageViewerList(dataList[0].date));
    }

    if (activeItem === 0) {
      dispatch(updateImageViewerDetails(dataList[activeItem]));
    }
  }, [activeItem, dispatch]);

  useEffect(() => {
    if (startIndex >= 0) {
      setActiveItem(startIndex);
    }
  }, [startIndex, setActiveItem]);

  const handleCloseClick = () => {
    dispatch(closeImageViewer());
  };

  if (!imageViewerData.showViewer) {
    return null;
  }

  return ReactDOM.createPortal(
    <ImageViewer
      show={imageViewerData.showViewer}
      handleClose={handleCloseClick}
      dataList={dataList}
      activeItem={activeItem}
      setActiveItem={setActiveItem}
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      zIndex="100001"
    />,
    document.getElementById("modal"),
  );
};

export default ImageViewerModule;
